import { ButtonProps, WisoryButton } from 'components/WisoryButton';
import { ReactElement } from 'react';

const ArrowLeftIcon = () => {
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 6.186c0 .324.116.599.347.825l5.015 5.007c.236.232.496.347.778.347.329 0 .593-.103.794-.308.205-.2.308-.45.308-.747a.955.955 0 0 0-.1-.447 1.219 1.219 0 0 0-.247-.354L5.17 8.782 2.62 6.44l-.477.7 2.997.163h8.705c.35 0 .63-.103.84-.309.21-.205.316-.475.316-.809 0-.333-.105-.603-.316-.808-.21-.206-.49-.309-.84-.309H5.14l-2.997.162.477.701L5.17 3.59l1.726-1.733c.103-.103.185-.219.247-.347.067-.134.1-.285.1-.455 0-.297-.103-.547-.308-.747C6.734.103 6.469 0 6.14 0a1 1 0 0 0-.408.092c-.134.057-.26.144-.378.262L.347 5.362C.116 5.583 0 5.858 0 6.186z"
        fill="#222"
      />
    </svg>
  );
};

export function PrevButton(props: ButtonProps): ReactElement {
  return <WisoryButton {...props} variant="secondary" icon={<ArrowLeftIcon />} iconPosition="left" />;
}
